<button class="whatsapp-btn" (click)="onClick()">
	Mensaje
	<img src="./assets/images/whatsapp-svgrepo-com-1.png" alt="WhatsApp logo" />
</button>
